import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { httpClient_default } from "./chunk-PXNCRHFK.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/fetcher/index.ts

var fetcher_exports = {};

__export(fetcher_exports, {
  "default": function _default() {
    return fetcher_default;
  }
});

import AsyncStorage from "@react-native-async-storage/async-storage";

var getHeader = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$isShop, isShop, storeId, token;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$isShop = _ref.isShop, isShop = _ref$isShop === void 0 ? false : _ref$isShop, storeId = _ref.storeId;
            token = "";
            _context.prev = 2;

            if (!isShop) {
              _context.next = 12;
              break;
            }

            _context.next = 6;
            return AsyncStorage.getItem("shopToken");

          case 6:
            _context.t1 = _context.sent;

            if (_context.t1) {
              _context.next = 9;
              break;
            }

            _context.t1 = "";

          case 9:
            _context.t0 = _context.t1;
            _context.next = 18;
            break;

          case 12:
            _context.next = 14;
            return AsyncStorage.getItem("accessToken");

          case 14:
            _context.t2 = _context.sent;

            if (_context.t2) {
              _context.next = 17;
              break;
            }

            _context.t2 = "";

          case 17:
            _context.t0 = _context.t2;

          case 18:
            token = _context.t0;
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t3 = _context["catch"](2);
            console.error("Error retrieving token from AsyncStorage:", _context.t3);
            token = "";

          case 25:
            return _context.abrupt("return", {
              Authorization: "Bearer ".concat(token),
              token: "".concat(token),
              "belong-store": storeId
            });

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 21]]);
  }));

  return function getHeader(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _getUrl = function getUrl(url, baseUrl) {
  return baseUrl.concat(url);
};

var apiUrl = "/cofit/api";
var searchGoogleKey = "AIzaSyBH1vnw69UWBSU_7VslDUALhXbvK4C54eM";
var searchAmapKey = "53534ee4701ca2a8eebbe0820fcf8e79";
var googleUrl = "https://maps.googleapis.com/maps/api";
var amapUrl = "http://restapi.amap.com/v3";
var fetcher = {
  get: function get(url, data, options) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var headers;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getHeader({});

            case 2:
              headers = _context2.sent;
              return _context2.abrupt("return", httpClient_default("GET", _getUrl(url, apiUrl), data, headers, options));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  post: function post(url, data) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var headers;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getHeader({});

            case 2:
              headers = _context3.sent;
              return _context3.abrupt("return", httpClient_default("POST", _getUrl(url, apiUrl), data, headers));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  uploadDirect: function uploadDirect(url, data, header) {
    return httpClient_default("POST", url, data, header, {
      // Content-Type needs to be removed for Gcloud Storage upload!!
      transformRequest: [function (d, h) {
        if (h && h.common) delete h.common["Content-Type"];
        return d;
      }]
    });
  },
  upload: function upload(url, data) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var headers;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getHeader({});

            case 2:
              headers = _context4.sent;
              return _context4.abrupt("return", httpClient_default("POST", _getUrl(url, apiUrl), data, headers));

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  "delete": function _delete(url, data) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var headers;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return getHeader({});

            case 2:
              headers = _context5.sent;
              return _context5.abrupt("return", httpClient_default("DELETE", _getUrl(url, apiUrl), data, headers));

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  put: function put(url, data) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var headers;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return getHeader({});

            case 2:
              headers = _context6.sent;
              return _context6.abrupt("return", httpClient_default("PUT", _getUrl(url, apiUrl), data, headers));

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  header: function header() {
    return getHeader({});
  },
  getUrl: function getUrl(url, apiUrl2) {
    return _getUrl(url, apiUrl2);
  },
  setBaseUrl: function setBaseUrl(url) {
    apiUrl = url;
  },
  getTramodern: function getTramodern(url, data) {
    return httpClient_default("GET", _getUrl(url, "http://www.chylyngiot.com:5569"), data, {});
  },
  getSearchGoogleLocationApi: function getSearchGoogleLocationApi(url, data) {
    return httpClient_default("GET", _getUrl(url, googleUrl), _objectSpread(_objectSpread({}, data), {}, {
      key: searchGoogleKey
    }), {});
  },
  getSearchAmapLocationApi: function getSearchAmapLocationApi(url, data) {
    return httpClient_default("GET", _getUrl(url, amapUrl), _objectSpread(_objectSpread({}, data), {}, {
      key: searchAmapKey
    }), {});
  }
};
var fetcher_default = fetcher;
export { fetcher_default, fetcher_exports };